var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelTiktokSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 14,
  viewBox: "0 0 12 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11.978 5.664q-.171.016-.344.018a3.74 3.74 0 0 1-3.127-1.69v5.755a4.253 4.253 0 1 1-4.254-4.254c.09 0 .176.008.263.014v2.096c-.087-.01-.173-.027-.263-.027a2.17 2.17 0 0 0 0 4.342c1.2 0 2.259-.945 2.259-2.144L6.532 0h2.006a3.735 3.735 0 0 0 3.442 3.335v2.33"
})));
export default SvgChannelTiktokSm;